import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import TagList from "../../store/models/TagList";
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  props: ['tagListId', 'deletedTagList'],
  methods: {
    deleteTagList: function deleteTagList() {
      var _this = this;

      this.$q.loading.show();
      this.loading = true;
      TagList.api().delete('/tag-lists/' + this.tagListId, {
        delete: this.tagListId
      }).then(function () {
        _this.$root.$emit('refresh-tags');

        _this.loading = false;

        _this.hide();

        _this.deletedTagList();

        _this.$q.notify({
          message: _this.$t('components.tagListDeleteDialog.taglist_deleted'),
          type: 'positive'
        });
      }).catch(function () {}).finally(function () {
        _this.$q.loading.hide();
      });
    }
  }
};